// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industory-box {
  width: 15vw;
  height: 15vw;
  background: #020c2e;
  border-radius: 1.85vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  padding: 12px;
  border: 5px solid #020c2e;
  font-family: Roboto !important;
}

.industryTextBox1 {
  pointer-events: none;
  background: linear-gradient(153deg, #ff8860 0%, #fff281 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.industryTextBox2 {
  pointer-events: none;
  background: var(--gradient-2, linear-gradient(180deg, #29d5a6 0%, #29b8ef 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.industryTextBox3 {
  pointer-events: none;
  background: linear-gradient(159deg, #6015e2 0%, #fb4794 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.industory-box span {
  text-align: center;
  font-size: 2vw;
  font-weight: 500;
  font-family: Roboto !important;
  word-break: keep-all;
}

.industory-box1 :hover {
  box-shadow: 0px 4px 50px 0px rgba(255, 187, 54, 0.5);
  border-radius: 1.85vw;
  border: 5px solid rgb(255, 136, 96);
}

.industory-box2 :hover {
  box-shadow: 0px 4px 50px 0px rgba(41, 213, 166, 0.5);
  border-radius: 1.85vw;
  border: 5px solid rgb(41, 213, 166);
}

.industory-box3 :hover {
  box-shadow: 0px 4px 50px 0px rgba(96, 21, 226, 0.5);
  border-radius: 1.85vw;
  border: 5px solid #b530b7;
}

@media (min-width: 1400px) and (max-width: 2560px) {
  .industory-box {
    width: 15vw;
    height: 15vw;
  }
  .industory-box span {
    text-align: center;
    font-size: 24px;
  }
}
@media (max-width: 768px) {
  .industory-box {
    width: 18vh;
    height: 19vh;
  }
  .industory-box span {
    text-align: center;
    font-size: 2.8vw;
  }
  .industory-box {
    border-radius: 1.2rem;
  }
  .industory-box1 :hover {
    border-radius: 1.2rem;
  }
  .industory-box2 :hover {
    border-radius: 1.2rem;
  }
  .industory-box3 :hover {
    border-radius: 1.2rem;
  }
}
@media (max-width: 500px) {
  .industory-box span {
    text-align: center;
    font-size: 5vw;
  }
  .industory-box {
    width: 25vh;
    height: 22vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/IndustoryBox/industoryBox.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,8BAAA;AACF;;AAEA;EACE,oBAAA;EACA,6DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AACF;;AAEA;EACE,oBAAA;EACA,gFAAA;EAIA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,6DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;EACA,oBAAA;AAFF;;AAKA;EACE,oDAAA;EACA,qBAAA;EACA,mCAAA;AAFF;;AAKA;EACE,oDAAA;EACA,qBAAA;EACA,mCAAA;AAFF;;AAKA;EACE,mDAAA;EACA,qBAAA;EACA,yBAAA;AAFF;;AAYA;EACE;IACE,WAAA;IACA,YAAA;EATF;EAaA;IACE,kBAAA;IACA,eAAA;EAXF;AACF;AAcA;EACE;IACE,WAAA;IACA,YAAA;EAZF;EAgBA;IACE,kBAAA;IACA,gBAAA;EAdF;EAiBA;IACE,qBAAA;EAfF;EAkBA;IACE,qBAAA;EAhBF;EAmBA;IACE,qBAAA;EAjBF;EAoBA;IACE,qBAAA;EAlBF;AACF;AAqBA;EACE;IACE,kBAAA;IACA,cAAA;EAnBF;EAqBA;IACE,WAAA;IACA,YAAA;EAnBF;AACF","sourcesContent":[".industory-box {\n  width: 15vw;\n  height: 15vw;\n  background: #020c2e;\n  border-radius: 1.85vw;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 10px;\n  padding: 12px;\n  border: 5px solid #020c2e;\n  font-family: Roboto !important;\n}\n\n.industryTextBox1 {\n  pointer-events: none;\n  background: linear-gradient(153deg, #ff8860 0%, #fff281 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.industryTextBox2 {\n  pointer-events: none;\n  background: var(\n    --gradient-2,\n    linear-gradient(180deg, #29d5a6 0%, #29b8ef 100%)\n  );\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.industryTextBox3 {\n  pointer-events: none;\n  background: linear-gradient(159deg, #6015e2 0%, #fb4794 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.industory-box span {\n  text-align: center;\n  font-size: 2vw;\n  font-weight:500;\n  font-family: Roboto !important;\n  word-break: keep-all;\n}\n\n.industory-box1 :hover {\n  box-shadow: 0px 4px 50px 0px rgba(255, 187, 54, 0.5);\n  border-radius: 1.85vw;\n  border: 5px solid rgb(255, 136, 96);\n}\n\n.industory-box2 :hover {\n  box-shadow: 0px 4px 50px 0px rgba(41, 213, 166, 0.5);\n  border-radius: 1.85vw;\n  border: 5px solid rgb(41, 213, 166);\n}\n\n.industory-box3 :hover {\n  box-shadow: 0px 4px 50px 0px rgba(96, 21, 226, 0.5);\n  border-radius: 1.85vw;\n  border: 5px solid #b530b7;\n}\n// @media (min-width: 1400px) {\n//   .industory-box span {\n//     // text-align: center;\n//     font-size: 30px !important;\n//   }\n// } \n  \n\n@media (min-width: 1400px) and (max-width:2560px) {\n  .industory-box {\n    width: 15vw;\n    height: 15vw;\n    \n  }\n\n  .industory-box span {\n    text-align: center;\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .industory-box {\n    width: 18vh;\n    height: 19vh;\n  }\n  \n\n  .industory-box span {\n    text-align: center;\n    font-size: 2.8vw;\n  }\n\n  .industory-box {\n    border-radius: 1.2rem;\n  }\n\n  .industory-box1 :hover {\n    border-radius: 1.2rem;\n  }\n\n  .industory-box2 :hover {\n    border-radius: 1.2rem;\n  }\n\n  .industory-box3 :hover {\n    border-radius: 1.2rem;\n  }\n}\n\n@media (max-width: 500px) { \n  .industory-box span {\n    text-align: center;\n    font-size: 5vw;\n  }\n  .industory-box {\n    width: 25vh;\n    height: 22vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
